import { render, staticRenderFns } from "./SiteHeader.vue?vue&type=template&id=718364c0&scoped=true&"
import script from "./SiteHeader.vue?vue&type=script&lang=ts&"
export * from "./SiteHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SiteHeader.vue?vue&type=style&index=0&id=718364c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718364c0",
  null
  
)

export default component.exports